import { render, staticRenderFns } from "./NavigationArrow.vue?vue&type=template&id=4e44b63c"
import script from "./NavigationArrow.vue?vue&type=script&lang=ts"
export * from "./NavigationArrow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports